import React, { useEffect, useState } from 'react';
import { where } from "firebase/firestore";
import { Link } from 'react-router-dom';
import { CommonCloudFirestore } from '../../../services/CommonCloudFirestore';
import { 
    DOCUMENT_SECTION, 
    DOCUMENT_SECTION_DETAIL,
    LISTENER_SECTIONS, 
    LISTENER_SECTION_DETAILS 
} from '../../../../shared/types/firestoreType';

import global from '../../../../shared/utility/global';
import storageManager from '../../../../shared/utility/storageManager';

import './styles.css';

export default function Index(props) {
    const commonSectionFirestore = new CommonCloudFirestore(DOCUMENT_SECTION);
    const commonSectionDetailFirestore = new CommonCloudFirestore(DOCUMENT_SECTION_DETAIL);

    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        setLoading(true);
        const condition = where("visible", "==", true);
        let sections = await storageManager.fetch(LISTENER_SECTIONS, async () => await commonSectionFirestore.getDocuments(condition));
        let details = await storageManager.fetch(LISTENER_SECTION_DETAILS, async () => await commonSectionDetailFirestore.getDocuments(condition));

        sections.forEach(element => {
            element.detail = details.filter(m => m.sectionId === element.id).sort(global.orderBy('index'));
        });

        setLoading(false);
        setSections(sections);
    };

    if (sections.filter(m => m.detail.length > 0)?.length === 0)
        return null;

    return (
        <>
            {
                sections.map(section => (
                    <div key={section.id} className="container mb-20">
                        <h2 className="pb-2 border-bottom mt-5">{section.title}</h2>
                        <div className="row row-cols-1 row-cols-lg-3 align-items-stretch g-3 py-3">
                            {
                                section.detail?.map(item => (
                                    <div key={item.id} className="col-lg-6">
                                        <Link to={`/product-section/${item.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <div className="square">
                                                <div className="square-content">
                                                    <img src={item.imageUrl} alt="card" />
                                                    <div className='info'>
                                                        <div className='vertical-center h-100'>
                                                            <div>
                                                                <div className='name'>
                                                                    {item.title}
                                                                </div>
                                                                <div className='short-description'>
                                                                    {item.subTitle}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                ))
            }
        </>
    );
}